import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-element"
export default class extends Controller {
  
  static values = { element: "span" }
  
  toggle() {
    const elements = this.element.querySelectorAll(this.elementValue)
    const currentElement = this.element.querySelector(`${this.elementValue}:not(.hidden)`)
    const nextElement = currentElement.nextElementSibling || currentElement.parentElement.firstElementChild
    elements.forEach(element => element.classList.add("hidden"))
    nextElement.classList.remove("hidden")
  }
  
}
